import { ConditionalFieldsGroupPresenter } from '@/forms/components/presenters/ConditionalFieldsGroupPresenter';
import {
  FormFieldType,
  type ConditionalFieldsGroupFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildConditionalFieldsGroupInitialState } from './initialState';

export const conditionalFieldsGroupFieldModule: FormFieldModule = {
  type: FormFieldType.ConditionalFieldsGroup,
  Presenter: ({ field }) => (
    <ConditionalFieldsGroupPresenter
      conditionalFieldsGroup={field as ConditionalFieldsGroupFormField}
    />
  ),
  flattenLeaves: (field, ctx) => {
    const f = field as ConditionalFieldsGroupFormField;
    return ctx.recurse([f.conditionField, ...f.children]);
  },
  buildInitialState: buildConditionalFieldsGroupInitialState,
};
